export const COMMUNUCATION_CHANNEL = "SMS";

export const SMS_NOTIFICATIONS_MESSAGE_CODES = {
	error: {
		invalidValueFormat: "E_VALIDATION_INVALIDVALUE_INVALIDFORMAT",
		ruteNotFound: "E_ROUTENOTFOUND",
		unhandled: "E_UNHANDLED",
		forbidden: "E_CURRENTCUSTOMER_SUBSCRIPTIONFORBIDDEN",
	},
	success: {
		getAllSuccess: "M_GET_ALL_SUCCESS",
		updateSuccess: "M_UPDATE_SUCCESS",
	},
};
